import { ALL_KNOWN_DETAILS_TESTIDS } from '../../constants';
import { labelFor, subLabelFor } from '../../utils/allKnownDetailsUtils';
import type { KnownDetailType, KnownEntityType, KnownSourceGroup } from '../../types';
import SourceValueRow from '../SourceValueRow/SourceValueRow';
import styles from './SourceGroupRow.module.scss';

interface SourceGroupRowProps {
    group: KnownSourceGroup;
    type: KnownDetailType;
    entityType: KnownEntityType;
}

const SourceGroupRow = ({ group, type, entityType }: SourceGroupRowProps) => (
    <div className={styles.SourceRow} data-testid={ALL_KNOWN_DETAILS_TESTIDS.SOURCE_ROW}>
        <SourceValueRow label={labelFor(group)} subLabel={subLabelFor(group, entityType)} values={group.values ?? []} type={type} />
    </div>
);

export default SourceGroupRow;
